export class grantTypeService {
    isMfaSession: boolean = false;
    isExternalLogin:boolean = false;
    setIsMfaSession = (val: boolean) => this.isMfaSession = val;
    setIsExternalLogin = (val:boolean) => this.isExternalLogin = val;

    initGrantTypeService = ({isMfa = false, isExternalLogin = false}: {isMfa?: boolean, isExternalLogin?: boolean}) => {
        this.isExternalLogin = isExternalLogin
        this.isMfaSession = isMfa;
    };

    isSingleFactorExternal = () => {
        return !this.isMfaSession && this.isExternalLogin
    }
}

export const GrantTypeService = new grantTypeService();